import React from "react"
import { Box } from "@xingternal/winery-ui/lib/Box"
import { Flex } from "@xingternal/winery-ui/lib/Flex"
import { Text } from "@xingternal/winery-ui/lib/Text"
import styled from "styled-components"
import themeGet from "@styled-system/theme-get"
import { RecruiterInsightsLicenseIcon } from "../RecruiterInsightsLicenseIcon"
import compose from "recompose/compose"
import { t } from "@/i18n"
import { withi18n } from "@/helpers/hoc/withi18n"
import { RECRUITER_INSIGHTS_COLOR } from "../../constants"

const i18ns = {
  recruiterInsights: "360_RECRUITER_INSIGHTS_TEXT",
  infolayerBody: "360_RECRUITER_INSIGHTS_INFOLAYER_BODY",
  infolayerFooter: "360_RECRUITER_INSIGHTS_INFOLAYER_FOOTER",
}

const Container = styled(Flex)`
  width: 368px;
  flex-direction: column;
  gap: ${themeGet("space.4")};
`

const Header = styled(Flex)`
  align-items: center;
  color: ${RECRUITER_INSIGHTS_COLOR};
  font-weight: bold;
  gap: ${themeGet("space.3")};
`

const LineDecorator = styled(Box)`
  border-top: 1px solid;
  flex: 1;
  color: ${RECRUITER_INSIGHTS_COLOR};
`

const InfolayerBody = styled(Text).attrs({ size: 1 })`
  white-space: pre-line;
  font-size: 14px;

  & > span > ul > li {
    display: list-item;
    list-style-type: disc;
    line-height: 1.5;
  }

  & > span > ul {
    line-height: 0;
    padding: ${themeGet("space.2")} 0 ${themeGet("space.2")}
      ${themeGet("space.5")};
  }
`

const FooterText = styled(Text)`
  font-size: 11px;
`

const RecruiterInsightsInfolayerContent = () => (
  <Container>
    <Header data-testid="ri-info-header">
      <LineDecorator />
      <Box>
        <RecruiterInsightsLicenseIcon />
      </Box>
      <Text>{t(i18ns.recruiterInsights)}</Text>
    </Header>
    <InfolayerBody data-testid="ri-info-body">
      <span dangerouslySetInnerHTML={{ __html: t(i18ns.infolayerBody) }} />
      <FooterText>{t(i18ns.infolayerFooter)}</FooterText>
    </InfolayerBody>
  </Container>
)

const enhance = compose(withi18n(i18ns))

export default enhance(RecruiterInsightsInfolayerContent)
